import stEmailSend from './emailSend.component';

export default angular
  .module('st.Integrations.Email', ['st.Core'])
  .component('stEmailSend', stEmailSend)
  .service('emailService', ($http, $rootScope, CacheFactory, dataService, INSTANCE, EMAIL) => ({
    getTicketEmail: (ticketUuid) =>
      `${String(ticketUuid).slice(0, -2).toLowerCase()}@${INSTANCE.inboundEMail}`,
    sendEmail: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        EMAIL.API.SEND_EMAIL,
        { params },
        ['idSender', 'subject', 'content']
      ),
    sendTo: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        EMAIL.API.SEND_TO,
        { params },
        ['recipient', 'subject', 'content']
      ),
    sendReferral: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        EMAIL.API.SEND_REFERRAL,
        { params },
        ['idSender', 'emailTo', 'subject', 'content']
      )
  }))
  .constant('EMAIL', {
    API: {
      SEND_EMAIL: '/api/v1/email/send-email/',
      SEND_TO: '/api/v1/email/send-to/',
      SEND_REFERRAL: '/api/v1/email/send-referral/'
    },
    LIMITS: {
      MULTIPLE: false,
      ALLOWED_MIME: 'image/*',
      ALLOWED_EXTENSIONS: '.jpeg,.jpg,.png',
      CROP_TYPE: 'rectangle',
      ASPECT_RATIO: '6',
      MIN_WIDTH: '600',
      MIN_HEIGHT: '250'
    }
  });
